(function () {
  'use strict';

  const d = function (value) {
    return window.atob(value);
  };

  const c = Object.freeze({
    a: d('LmZvb3Rlci5mb290ZXItc2VjcmV0'),
    b: d('LmZvb3Rlci1jb3B5cmlnaHQgLmNvcHlyaWdodC1jb250ZW50'),
    c: d('LmNvcHlyaWdodC1sb2dv'),
    d: d('LmNvcHlyaWdodC1wYXltZW50cw=='),
    e: d('Zm9vdGVyLWxvZ28tc3Zn'),
    f: d('aHR0cHM6Ly93d3cuYWxmaW5ldC5jb20uYnIv'),
    g: d('aHR0cHM6Ly9jZG4uc2hvcGlmeS5jb20vcy9maWxlcy8xLzA3NTAvMTAzMS8wMzgyL2ZpbGVzL2xmaW5ldGUuc3ZnP3Y9MTc4MjgyOTMzMg=='),
    h: d('TG9nb3RpcG8=')
  });

  let frame = null;

  function setAttribute(element, attribute, value) {
    if (element.getAttribute(attribute) !== value) {
      element.setAttribute(attribute, value);
    }
  }

  function createImage() {
    const image = document.createElement('img');

    setAttribute(image, 'src', c.g);
    setAttribute(image, 'alt', c.h);
    setAttribute(image, 'loading', 'lazy');

    return image;
  }

  function createLink() {
    const link = document.createElement('a');

    setAttribute(link, 'href', c.f);
    setAttribute(link, 'rel', 'noopener');

    link.className = c.e;
    link.appendChild(createImage());

    return link;
  }

  function createWrapper() {
    const wrapper = document.createElement('div');

    wrapper.className = c.c.substring(1);
    wrapper.appendChild(createLink());

    return wrapper;
  }

  function synchronize() {
    const root = document.querySelector(c.a);

    if (!root) return;

    const content = root.querySelector(c.b);

    if (!content) return;

    let wrapper = content.querySelector(c.c);

    if (!wrapper) {
      wrapper = createWrapper();

      const payments = content.querySelector(c.d);

      if (payments) {
        content.insertBefore(wrapper, payments);
      } else {
        content.appendChild(wrapper);
      }

      return;
    }

    if (!wrapper.classList.contains(c.c.substring(1))) {
      wrapper.classList.add(c.c.substring(1));
    }

    let link = wrapper.querySelector('a');

    if (!link) {
      wrapper.appendChild(createLink());
      return;
    }

    setAttribute(link, 'href', c.f);
    setAttribute(link, 'rel', 'noopener');

    if (!link.classList.contains(c.e)) {
      link.classList.add(c.e);
    }

    let image = link.querySelector('img');

    if (!image) {
      image = createImage();
      link.appendChild(image);
      return;
    }

    setAttribute(image, 'src', c.g);
    setAttribute(image, 'alt', c.h);
    setAttribute(image, 'loading', 'lazy');
  }

  function schedule() {
    if (frame !== null) return;

    frame = window.requestAnimationFrame(function () {
      frame = null;
      synchronize();
    });
  }

  function initialize() {
    synchronize();

    const observer = new MutationObserver(schedule);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'href',
        'src',
        'class',
        'rel'
      ]
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();